import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function authHeaders() {
  const token = localStorage.getItem("do_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function errCode(e) {
  const d = e?.response?.data?.detail;
  if (d && typeof d === "object" && !Array.isArray(d) && typeof d.code === "string") return d.code;
  return "GENERIC";
}

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function startGoogleLogin(portal) {
  sessionStorage.setItem("do_auth_portal", portal);
  const redirectUrl = window.location.origin + "/auth/callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export function AuthProvider({ children }) {
  // null = checking session, false = guest, object = authenticated user
  const [user, setUser] = useState(null);

  useEffect(() => {
    // CRITICAL: returning from OAuth — let AuthCallback exchange the session_id first.
    if (window.location.hash?.includes("session_id=")) { setUser(false); return; }
    const token = localStorage.getItem("do_token");
    axios
      .get(`${API}/auth/me`, { headers: token ? { Authorization: `Bearer ${token}` } : {}, withCredentials: true })
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("do_token");
        setUser(false);
      });
  }, []);

  const saveSession = useCallback((data) => {
    localStorage.setItem("do_token", data.token);
    setUser(data.user);
  }, []);

  const refreshUser = useCallback(async () => {
    const { data } = await axios.get(`${API}/auth/me`, { headers: authHeaders(), withCredentials: true });
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(() => {
    axios.post(`${API}/auth/logout`, {}, { headers: authHeaders(), withCredentials: true }).catch(() => {});
    localStorage.removeItem("do_token");
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, saveSession, refreshUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
